const initialState = {
    "paso" : 0,
    "pasoInvitado": 0,
    "listaFamiliares": [],
    "listaPolizas": [],
    "listaGuardar": [],
    "listaVigencia": {},
    "familiar" : {
        "nombre": "",
        "email": "",
        "polizas" : []
    },
    "sinPolizas": false
}

export function accesoFamiliarRdc(state = initialState, action) {
    switch (action.type) {
        case "AF_LISTA_FAMILIARES":
            return {...state,
                "listaFamiliares": action.listaFamiliares
            };
        case "AF_LISTA_POLIZAS":
            return {...state,
                "listaPolizas": action.listaPolizas
            };
        case "AF_EDITAR_FAMILIAR":
            return {...state,
                "familiar": action.familiar
            };
        case "AF_SIN_POLIZAS":
            return {...state,
                "sinPolizas": action.sinPolizas
            }
        case "AF_EDITAR_POLIZAS":
            return {...state,
                "listaGuardar": action.listaGuardar
            };
        case "AF_EDITAR_VIGENCIA":
            return {...state,
                "listaVigencia": action.listaVigencia
            };
        case "AF_EDITAR_PASO":
            return {...state,
                "paso": action.paso
            };
        case "AF_EDITAR_PASO_INVITADO":
            return {...state,
                "pasoInvitado": action.pasoInvitado
            };
        case "AF_SET_EVENT":
            return {...state,
                "evento": action.evento
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/acceso-familiar/reducer.js